import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Play } from 'lucide-react';
import FlexFullwidthCard from '../Views/FlexFullwidthCard';

// Video cards show a still frame pulled from the video itself, which on its
// own is indistinguishable from a photo. The play badge marks it as a
// preview and makes the card read as "click to watch".
const playBadge = (
  <span className="cards__play-badge" aria-hidden="true">
    <Play size={26} fill="currentColor" strokeWidth={0} />
  </span>
);

const FlexVideoCard = memo(({ item, compact, hideLink, gridLayout }) => (
  <FlexFullwidthCard
    item={item}
    compact={compact}
    hideLink={hideLink}
    gridLayout={gridLayout}
    imageOverlay={playBadge}
  />
));

FlexVideoCard.propTypes = {
  item: PropTypes.shape({
    '@id': PropTypes.string.isRequired,
  }).isRequired,
  compact: PropTypes.bool,
  hideLink: PropTypes.bool,
  gridLayout: PropTypes.bool,
};

export default FlexVideoCard;
